import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { settings } from "@/lib/utils/settings/settings";

export interface AuthInfo {
	access_token: string;
	refresh_token: string;
	id_token: string;
	expires_in: number;
	token_type: string;
}

interface DecodedToken {
	email: string;
	username: string;
	client_id: string;
	"cognito:groups"?: string[];
}

const authUrl = settings.authUrl;
const clientId = settings.oauthClientId;

const postTokenRequest = async (params: URLSearchParams): Promise<AuthInfo> => {
	try {
		const response = await axios.post(`${authUrl}/oauth2/token`, params, {
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
			},
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw new Error(
				error.response?.data?.error_description || "Error processing token",
			);
		}

		throw new Error("Unexpected error processing token");
	}
};

export const generateToken = async (authCode: string): Promise<AuthInfo> => {
	const params = new URLSearchParams({
		grant_type: "authorization_code",
		code: authCode,
		client_id: clientId,
		redirect_uri: `${window.location.origin}/auth`,
	});

	return await postTokenRequest(params);
};

export const refreshToken = async (refreshToken: string): Promise<AuthInfo> => {
	const params = new URLSearchParams({
		grant_type: "refresh_token",
		refresh_token: refreshToken,
		client_id: clientId,
	});
	return await postTokenRequest(params);
};

export const decodeToken = (token: string): DecodedToken => {
	return jwtDecode<DecodedToken>(token);
};
